import { inject, type InjectionKey } from "vue";
import type { ApiClient } from "./types";

export const apiKey: InjectionKey<ApiClient> = Symbol("api");

export function useApi(): ApiClient {
  const api = inject(apiKey);
  if (!api) {
    throw new Error("API client not installed. Did you forget app.provide(apiKey, ...) in main.ts?");
  }
  return api;
}
